export default [
  {
    path: '/admin',
    component: () => import('../Admin'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: 'home',
      },
      {
        path: 'home',
        name: 'AdminHome',
        component: () => import('../components/home/Home'),
      },
      {
        path: 'notification',
        name: 'AdminNotifications',
        component: () => import('../components/notification/Notifications'),
      }
    ]
  },
];
